export const SettingTypes = {
    APPLICATION: "همه اپلیکیشن ها",
    ANDROID: "اندروید",
    IOS: "آی او اس",
    WEB_PANEL: "پنل ادمین",
    GENERAL: "عمومی",
    WEB_APP: "وب اپلیکیشن",
    WEB_MASTER: "وب اپلیکیشن مراکز",
    WEB_CORPORATE: "وب اپلیکیشن شرکت ها"
}
